import * as React from 'react';
import { useIsMobileHook } from '@telia-common-components/shared';
import { Separator } from 'telia-front-react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { useInternetNotices } from '../InternetNoticesProvider';
import { useInternetOffers } from '../InternetOffersProvider';
import { CUSTOMER_TYPE_BUSINESS, CUSTOMER_TYPE_PRIVATE, getCustomerIdFromAuth, getIsDealerFromAuth, getSegment, isDealerWithoutCustomer, } from '../util/InternetCalculatorUtil';
import { AddressProductsNotices } from './AddressProductsNotices';
import { ChangeSegmentNotice } from './ChangeSegmentNotice';
import { DealerWithoutCustomerError } from './DealerWithoutCustomerError';
import { DebtOrNegativeCreditNotice } from './DebtOrNegativeCreditNotice';
import MissingMandateNotice from './MissingMandateNotice';
import { OfferTechnologyNotices } from './OfferTechnologyNotices';
import { RepresentationStipulationNotice } from './RepresentationStipulationNotice';
export const NOTICES_ABOVE_SPEED_SUGGEST_CALC_DIV_ID = 'notices-above-speed-suggest-calculator';
export const CustomerNotices = () => {
    var _a;
    const { addressProductsState, calculatorState } = useInternetOffers();
    const { auth, isSecureNet } = useInternetCalculator();
    const { hasLegalOrServiceMandateState, representationStipulationState, hasCreditOrDebtErrors } = useInternetNotices();
    const isDealer = getIsDealerFromAuth(auth);
    const customerId = getCustomerIdFromAuth(auth);
    const segment = getSegment(auth);
    const { isMobile } = useIsMobileHook();
    const addressHasProducts = (_a = addressProductsState === null || addressProductsState === void 0 ? void 0 : addressProductsState.addressProducts) === null || _a === void 0 ? void 0 : _a.addressHasProducts;
    const showDealerWithoutCustomerNotice = !!calculatorState.address && isDealerWithoutCustomer(isDealer, customerId);
    const getCustomerBasedNotice = (hasAddressProductNotice) => {
        const customerBasedNotice = () => {
            if (((segment === CUSTOMER_TYPE_PRIVATE && isSecureNet) || (!isSecureNet && segment === CUSTOMER_TYPE_BUSINESS)) && calculatorState.address) {
                return React.createElement(ChangeSegmentNotice, null);
            }
            if (customerId && calculatorState.address && !hasLegalOrServiceMandateState.hasMandate) {
                return React.createElement(MissingMandateNotice, null);
            }
            if (!!customerId && calculatorState.address && hasCreditOrDebtErrors()) {
                return React.createElement(DebtOrNegativeCreditNotice, null);
            }
            return null;
        };
        const customerNotice = customerBasedNotice();
        if (!!customerNotice) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Separator, { spacing: isMobile || hasAddressProductNotice ? 'xsmall' : 'small', color: "invisible" }),
                customerNotice));
        }
        if (isSecureNet && !!representationStipulationState.stipulation) {
            return React.createElement(RepresentationStipulationNotice, null);
        }
        return showDealerWithoutCustomerNotice ? React.createElement(DealerWithoutCustomerError, { addressSelected: !!calculatorState.address }) : null;
    };
    return (React.createElement("div", { id: NOTICES_ABOVE_SPEED_SUGGEST_CALC_DIV_ID },
        addressHasProducts && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: isMobile ? 'xsmall' : 'small', color: "invisible" }),
            React.createElement(AddressProductsNotices, null))),
        getCustomerBasedNotice(addressHasProducts),
        isSecureNet && !getCustomerBasedNotice(addressHasProducts) && React.createElement(OfferTechnologyNotices, null)));
};
